//
// Module for the Interest Index view
//
rs.module("content/participant/member/interest/index",

    [
        "controls/data/grid",
        "common/visibility"
    ],

    function (gridModule, visibility) {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, codeValues, ajaxUrl) {

            var filter = $.js(jsSelectors.filter);
            var interestTypeIndicator = filter.js(jsSelectors.interestTypeIndicator, { multiple: true });
            var includeCancelledContainer = filter.js(jsSelectors.includeCancelledContainer);
            var includeCancelledCheckbox = filter.js(jsSelectors.includeCancelledCheckbox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Hook up click event on the radio buttons to reload the grid data via ajax
            interestTypeIndicator.find("input").on("click", reloadGrid);

            // Hook up click event on the include cancelled checkbox to reload the grid data via ajax
            includeCancelledCheckbox.on('click', reloadGrid)

            // retrieve the grid data and refresh the grid
            function reloadGrid() {
                var selectedInterestType = interestTypeIndicator.find("input:checked").val();
                var isTrialSelected = selectedInterestType == codeValues.trial;
                visibility.setVisible(includeCancelledContainer, !isTrialSelected);
                if (isTrialSelected) {
                    includeCancelledCheckbox.setChecked(false);
                }

                loadingSpinner.show();

                gridModule.update(

                    ajaxUrl,
                    {
                        selectedBatchStatus: selectedInterestType,
                        includeCancelled: includeCancelledCheckbox.prop("checked")
                    },

                    lrsGridApi.agGridApi,

                    function done(gridUpdate) {
                        loadingSpinner.hide();
                        visibility.setVisible($.js(jsSelectors.addButton), gridUpdate.context.selectedBatchStatus != codeValues.trial);
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);